import { render } from "./teacher-page-header.vue?vue&type=template&id=719cdfca&ts=true"
import script from "./teacher-page-header.ts?vue&type=script&lang=ts&external"
export * from "./teacher-page-header.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__